import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${title} - Roda de Prêmios`;
    
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};
